import UserIndex from '@/views/User/UserIndex.vue'
import UserLogin from '@/views/User/UserLogin.vue'
import UserResetPwd from '@/views/User/UserResetPwd.vue'
import UserForgetPwd from '@/views/User/UserForgetPwd.vue'

const public_routes = [
  { path: '/', redirect: '/login' },
	{
		name: '登入',
		path: '/login',
      component: UserIndex,
      children: [
          {
            path: "/login",
            name: "管理員登入",
            component: UserLogin,
            meta: {
              is_required_auth: false,
              is_show_sidebar: false,
            }
          },
          {
            path: "/reset_password",
            name: "重設密碼",
            component: UserResetPwd,
            meta: {
              is_required_auth: false,
              is_show_sidebar: false,
            }
          },
          {
            path: '/forget_password',
            name: "忘記密碼",
            component: UserForgetPwd,
            meta: {
              is_required_auth: false,
              is_show_sidebar: false,
            }
          }
      ]
	},
]

export default public_routes